/* */ 
"use strict";
var lang_1 = require('../facade/lang');
var CAMEL_CASE_REGEXP = /([A-Z])/g;
var DASH_CASE_REGEXP = /-([a-z])/g;
function camelCaseToDashCase(input) {
  return lang_1.StringWrapper.replaceAllMapped(input, CAMEL_CASE_REGEXP, function(m) {
    return '-' + m[1].toLowerCase();
  });
}
exports.camelCaseToDashCase = camelCaseToDashCase;
function dashCaseToCamelCase(input) {
  return lang_1.StringWrapper.replaceAllMapped(input, DASH_CASE_REGEXP, function(m) {
    return m[1].toUpperCase();
  });
}
exports.dashCaseToCamelCase = dashCaseToCamelCase;
